

const metaTag = document.querySelector('meta[name="keywords"]');
const h1Text = document.querySelector('h1').textContent;
const content = metaTag.getAttribute('content');
const textsToRemove = [
  "openen in modaal",
  "Ga direct naar productinformatie",
  "1",
  "/",
  "van",
  "8"
];

const newContent = content
  .split('\n')
  .filter(line => !textsToRemove.some(text => line.includes(text)))
  .join('\n');

metaTag.setAttribute('content', h1Text);

const heading = $0;
const parent = heading.parentElement;
const shopBijSpan = parent.querySelector('span');
shopBijSpan.setAttribute('aria-hidden', 'true');
const data = {
  spanAriaHidden: shopBijSpan.getAttribute('aria-hidden'),
  spanText: shopBijSpan.textContent,
  headingText: heading.textContent,
};

document.addEventListener("DOMContentLoaded", function () {
    const stickyAtc = document.getElementById("sticky-atc");
    const footer = document.querySelector("footer.footer");

    if (stickyAtc && footer) {
        const observer = new IntersectionObserver(
            ([entry]) => {
                if (entry.isIntersecting) {
                    // Hide the sticky ATC button when the footer is visible
                    stickyAtc.classList.add("hidden");
                } else {
                    // Show the sticky ATC button when the footer is not visible
                    stickyAtc.classList.remove("hidden");
                }
            },
            {
                root: null, // Use the viewport as the root
                threshold: 0.1, // Trigger when 10% of the footer is visible
            }
        );

        observer.observe(footer);
    }
});
